import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Fade from 'react-reveal/Fade';

export default function JustRow(props){
    return(
        <section className={["justRow",props.className].join(" ")}>
            <Container fluid={props.fluid}>
                {props.title ? <Fade top distance="30px"><h3 className="rowTitle">{props.title}</h3></Fade> : null}
                {props.description ? <Fade bottom distance="30px"><div className="description rowDescriptDon">{props.description}</div></Fade> : null}
                <Row className={props.rowClass ? props.rowClass : ""}>
                    {props.children}
                </Row>
            </Container>
        </section>
    )
}